<template>
    <div>
        <b-row>
            <b-col cols="12" class="mb-3">
                <h1>Операции с пользователями</h1>
            </b-col>
            <b-col cols="12" class="mb-3" style="background: rgb(235 235 235); padding: 15px 15px;">
                <h5 class="mb-3">Перевод компаний с одного пользователя на другого</h5>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label>Чьи компании переводим</label>
                        <tsoft-select-user
                          id="from_user_id"
                          :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager`"
                          :needNullElement="true"
                          :selected="companiesTransferParams.from_user_id"
                          @set="setCompaniesTransferParamsFrom"
                          :disabled="savingProcess.companiesTransfer"
                          :withoutFired="false"
                        ></tsoft-select-user>
                    </div>
                    <div class="form-group col-md-4">
                        <label>На кого переводим</label>
                        <tsoft-select-user
                            id="to_user_id"
                            :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager`"
                            :needNullElement="true"
                            :selected="companiesTransferParams.to_user_id"
                            @set="setCompaniesTransferParamsTo"
                            :disabled="savingProcess.companiesTransfer"
                            :withoutFired="false"
                        ></tsoft-select-user>
                    </div>
                    <div class="form-group col-md-8">
                        <div class="text-right">
                            <button
                                class="btn btn-outline-primary"
                                @click="companiesTransfer()">Подвердить операцию<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess.companiesTransfer"></i></button>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>        
    </div>
</template>

<script>
    import {
        defaultDataItems,
    } from '@/mixins'

    export default {
        mixins: [
            defaultDataItems
        ],
        data() {
            return {
                savingProcess: {
                    companiesTransfer: false
                },
                companiesTransferParams: {
                    from_user_id: null,
                    to_user_id: null
                }
            };
        },
        components: {
        },
        mounted() {
        },
        watch: {
        },
        methods: {
            companiesTransfer() {
                this.savingProcess.companiesTransfer = true;

                api.call("post", "/api/users/operations/companies-transfer", this.companiesTransferParams).then(({data}) => {
                    this.savingProcess.companiesTransfer = false;

                    let mess = 'Укажите пользователей в полях выше!';
                    let variant = 'info';

                    if (data['sales_manager_user_id'] >= 0) {
                        mess = `Обновили компаний: по сейлзу ${data['sales_manager_user_id']} шт.; по ТЭО ${data['teo_manager_user_id']} шт.; по ТО ${data['to_manager_user_id']} шт.`;
                        variant = 'success'
                    }

                    this.makeToast(variant, mess, 6000)
                }).catch((response) => {
                    this.makeToast('danger', response, 6000)
                })                
            },
            setCompaniesTransferParamsFrom(value) {
              this.companiesTransferParams.from_user_id = value
            },
            setCompaniesTransferParamsTo(value) {
              this.companiesTransferParams.to_user_id = value
            },
        },
    }
</script>
<style scoped>

</style>
